import { Models } from "appwrite";
import { Link } from "react-router-dom";

type UserCardProps = {
  user: Models.Document;
  showTrustScore?: boolean;
};

const UserCard = ({ user, showTrustScore = false }: UserCardProps) => {
  const RoleBadge = ({ role }: { role: string }) => {
    const roleStyles = {
      'skilled-employee': 'bg-blue-500/20 text-blue-600',
      'unskilled-employee': 'bg-purple-500/20 text-purple-600',
      'business-owner': 'bg-amber-500/20 text-amber-600'
    }[role] || 'bg-gray-500/20 text-gray-600';
  
    const roleLabels = {
      'skilled-employee': 'Skilled',
      'unskilled-employee': 'Unemployed',
      'business-owner': 'Business Owner'
    }[role] || role;
  
    return (
      <span className={`text-xs px-2 py-1 rounded-full font-medium ${roleStyles}`}>
        {roleLabels}
      </span>
    );
  };
  return (
    <Link to={`/profile/${user.$id}`} className="user-card">
      <img
        src={user.imageUrl || "/assets/icons/profile-placeholder.svg"}
        alt="creator"
        className="rounded-full w-14 h-14"
      />

      <div className="flex-center flex-col gap-1">
        <p className="base-medium text-light-1 text-center line-clamp-1">
          {user.name}
        </p>
        <p className="small-regular text-light-3 text-center line-clamp-1">
          @{user.username}
        </p>
      </div>

      {showTrustScore && user.individual && (
        <p className="small-regular text-light-3 text-center line-clamp-1">
          <RoleBadge role={user.individual} />
        </p>
      )}
    </Link>
  );
};

export default UserCard;